var _circle, _circle2, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 59.25,
    stroke: "url(#paint0_linear_1074_700)",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.3419 49.4082L78 57.7501L62.25 42.0001L70.5919 33.6582C71.0138 33.2366 71.5859 32.9998 72.1823 32.9998C72.7788 32.9998 73.3509 33.2366 73.7728 33.6582L86.3419 46.2189C86.5519 46.4279 86.7186 46.6764 86.8323 46.9501C86.946 47.2238 87.0046 47.5172 87.0046 47.8136C87.0046 48.1099 86.946 48.4033 86.8323 48.677C86.7186 48.9507 86.5519 49.1992 86.3419 49.4082Z",
    fill: "url(#paint1_linear_1074_700)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9338 44.6354L75.3647 32.0691C74.9468 31.6511 74.4507 31.3196 73.9047 31.0934C73.3587 30.8672 72.7734 30.7507 72.1824 30.7507C71.5913 30.7507 71.0061 30.8672 70.4601 31.0934C69.914 31.3196 69.4179 31.6511 69 32.0691L34.3191 66.7501C33.8994 67.1664 33.5667 67.662 33.3402 68.2081C33.1138 68.7542 32.9981 69.3398 33 69.931V82.5001C33 83.6935 33.4741 84.8381 34.318 85.682C35.162 86.5259 36.3065 87.0001 37.5 87.0001H84.75C85.3468 87.0001 85.9191 86.763 86.341 86.341C86.763 85.9191 87 85.3468 87 84.7501C87 84.1533 86.763 83.581 86.341 83.1591C85.9191 82.7371 85.3468 82.5001 84.75 82.5001H56.4338L87.9338 51.0001C88.3518 50.5822 88.6833 50.0861 88.9095 49.54C89.1357 48.994 89.2522 48.4087 89.2522 47.8177C89.2522 47.2267 89.1357 46.6414 88.9095 46.0954C88.6833 45.5494 88.3518 45.0532 87.9338 44.6354ZM37.5 69.931L62.25 45.181L74.8191 57.7501L50.0691 82.5001H37.5V69.931ZM78 54.5691L65.4338 42.0001L72.1838 35.2501L84.75 47.8191L78 54.5691Z",
    fill: "url(#paint2_linear_1074_700)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1074_700",
    x1: 0,
    y1: 120,
    x2: 90.5973,
    y2: 89.6441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1074_700",
    x1: 62.25,
    y1: 57.7501,
    x2: 80.9385,
    y2: 51.4872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1074_700",
    x1: 33,
    y1: 87.0001,
    x2: 75.4687,
    y2: 72.7696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencicon);
export default __webpack_public_path__ + "static/media/pencicon.a2ddc1f66ea3121b5220c15664b4fc5b.svg";
export { ForwardRef as ReactComponent };